import React, { useEffect, useState } from "react";
import { useDoctorSlots } from "./store";
import ListView from "modules/doctor_booking/ListView";
import CalendarView from "modules/doctor_booking/CalendarView";
import { useLocation, useNavigate } from "react-router-dom";
import { Tab, Tabs } from "react-bootstrap";

function DoctorBooking() {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const sd = searchParams.get("sd");
  const ed = searchParams.get("ed");
  const { startingDate, endingDate, setDates } = useDoctorSlots();
  const { doctorSlotsData,isLoading, fetchDoctorSlots } = useDoctorSlots();
  const [status, setStatus] = useState([]);
  const [doctorsFilter, setDoctorsFilter] = useState([]);
  const [paymentFilter, setPaymentFilter] = useState([]);
  const [doctorSlots, setDoctorSlots] = useState({});
  const [tabType, setTabType] = useState("list");
  const [activeTab, setActiveTab] = useState("list");

  useEffect(() => {
    setDates(sd, ed);
    fetchDoctorSlots(activeTab, status, doctorsFilter, paymentFilter);
  }, [status, doctorsFilter, paymentFilter, activeTab, sd, ed]);

  function convertDateFormat(inputDate) {
    const dateObj = new Date(inputDate);
    const outputDate = dateObj.toISOString();
    const encodedDate = encodeURIComponent(outputDate);
    return encodedDate;
  }

  useEffect(() => {
    if (startingDate && endingDate) {
      const startDate = convertDateFormat(startingDate);
      const endDate = convertDateFormat(endingDate);
      const url = `/doctor-booking?sd=${startDate}&ed=${endDate}`;
      navigate(url);
    }
  }, [startingDate, endingDate]);

  useEffect(() => {
    setDoctorSlots(doctorSlotsData);
  }, [doctorSlotsData]);

  const handleTabChange = (eventKey) => {
    setActiveTab(eventKey);
  };

  return (
    <Tabs
      variant="pills"
      defaultActiveKey="list"
      id="uncontrolled-tab-example"
      className="mb-1 border-bottom pb-2"
      activeKey={activeTab}
      onSelect={handleTabChange}
    >
      <Tab eventKey="list" title="List View" className="">
        <ListView
          status={status}
          setStatus={setStatus}
          setTabType={setTabType}
          doctorSlots={doctorSlots}
          setDoctorsFilter={setDoctorsFilter}
          setPaymentFilter={setPaymentFilter}
          isLoading={isLoading}
        />
      </Tab>
      <Tab eventKey="calendar" title="Calendar View" className="">
        <CalendarView setTabType={setTabType} />
      </Tab>
    </Tabs>
  );
}

export default DoctorBooking;
